import { Listing, useCurrentUserQuery, useListingLazyQuery } from '@/api'
import { getCheckedItems } from '@/lib/checkedItems'
import { useEffect, useState } from 'react'

export const useCheckedItems = () => {
  const { data: userData } = useCurrentUserQuery({
    variables: {
      perPage: 10,
    },
    fetchPolicy: 'cache-and-network',
  })

  const [getListing] = useListingLazyQuery({
    fetchPolicy: 'cache-and-network',
  })

  const [localListings, setLocalListings] = useState<Listing[]>([])
  const [loading, setLoading] = useState(false)

  const currentUser = userData?.currentUser
  const isAuthenticated = Boolean(currentUser?.id)

  const recentViewedListings = currentUser?.recentViewedListings ?? []

  useEffect(() => {
    if (isAuthenticated) {
      setLocalListings([])
      return
    }

    const fetchLocalListings = async () => {
      const uuids = getCheckedItems()
      if (uuids.length === 0) {
        setLocalListings([])
        return
      }

      setLoading(true)
      try {
        const listings = await Promise.all(
          uuids.map(async (uuid) => {
            try {
              const result = await getListing({
                variables: { uuid },
              })
              return result.data?.listing
            } catch (error) {
              console.error(`Failed to fetch listing ${uuid}:`, error)
              return null
            }
          })
        )

        const validListings = listings.filter(
          (listing): listing is Listing =>
            listing !== null && listing !== undefined
        )
        setLocalListings(validListings)
      } catch (error) {
        console.error('Failed to fetch local listings:', error)
        setLocalListings([])
      } finally {
        setLoading(false)
      }
    }

    fetchLocalListings()
  }, [isAuthenticated, getListing])

  const listings = isAuthenticated ? recentViewedListings : localListings

  return {
    listings,
    loading,
    isAuthenticated,
  }
}
